// Utility functions for handling URLs in different environments.
// All URL resolution uses window.location hostname detection -- no env vars needed.
import { ACCOUNT_SOCKET_PATH } from '../types';
import { createLogger } from './logger';
const logger = createLogger('getUrl');
// Constants
const LOCALHOST_PORT = '3001';
const PRODUCTION_API_HOST = 'api.airheadgames.com';
const PRODUCTION_FRONTEND_HOST = 'airheadgames.com';
/** LAN dev: use the same host the browser used (DHCP-safe). Never hardcode a 192.168.* IP. */
function getLanHostname() {
    if (typeof globalThis === 'undefined' || !('location' in globalThis)) {
        return 'localhost';
    }
    return globalThis.location.hostname;
}
// Environment detection
const getEnvironment = () => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost')
        return 'local';
    if (hostname.startsWith('192.168'))
        return 'network';
    return 'production';
};
const getHostForEnvironment = (env, includePort = true) => {
    const port = includePort ? `:${LOCALHOST_PORT}` : '';
    switch (env) {
        case 'local':
            return `localhost${port}`;
        case 'network':
            return `${getLanHostname()}${port}`;
        case 'production':
            return PRODUCTION_API_HOST;
        default:
            return PRODUCTION_API_HOST;
    }
};
export const getBaseUrl = () => {
    const env = getEnvironment();
    const host = getHostForEnvironment(env);
    const protocol = env === 'production' ? 'https' : 'http';
    return `${protocol}://${host}`;
};
/**
 * Returns the backend WebSocket URL for a path, using the correct protocol and host.
 * - Uses hardcoded URLs for development environments
 * - Uses 'ws' or 'wss' based on the current page protocol.
 */
const getWebSocketUrl = (path) => {
    const env = getEnvironment();
    // Force ws:// for local development to avoid mobile Safari wss:// issues
    const isLocalDev = env === 'local' || env === 'network';
    const wsProtocol = isLocalDev
        ? 'ws:'
        : window.location.protocol === 'https:'
            ? 'wss:'
            : 'ws:';
    const host = getHostForEnvironment(env);
    return `${wsProtocol}//${host}${path}`;
};
/** The room socket URL for a room code. */
export const getRoomWebSocketUrl = (roomCode) => getWebSocketUrl(`/room/${roomCode}`);
/** The signed-in user's account socket URL. */
export const getAccountWebSocketUrl = () => getWebSocketUrl(ACCOUNT_SOCKET_PATH);
export const getFrontendUrl = () => {
    try {
        const { protocol, hostname, port } = window.location;
        // Dev with explicit port (Vite): join links match how you opened the app.
        // For phone testing, open the app via the dev server "Network" URL so links use that host.
        if (port) {
            return `${protocol}//${hostname}:${port}`;
        }
        return `${protocol}//${hostname}`;
    }
    catch (error) {
        logger.error('Error getting frontend URL:', error);
        // Fallback to a default URL if needed
        return `https://${PRODUCTION_FRONTEND_HOST}`;
    }
};
//# sourceMappingURL=getUrl.js.map